import { useState, useRef } from 'react'
import fetchPreCheckUpdateId from '../services/pre-check-form-update-id'

const MAX_ATTEMPTS = 12
const POLL_INTERVAL_MS = 6000

export function useVerificationPolling({ key, formUpdateIdRef, onSuccess, onFailure }) {
    const [isFetching, setIsFetching] = useState(false)
    const [progressStatus, setProgressStatus] = useState(null)

    const progressStatusRef = useRef(null)
    progressStatusRef.current = progressStatus

    // Always-fresh refs so async callbacks never capture stale closures
    const onSuccessRef = useRef(onSuccess)
    onSuccessRef.current = onSuccess
    const onFailureRef = useRef(onFailure)
    onFailureRef.current = onFailure

    const timeoutRef = useRef(null)
    const attemptsRef = useRef(0)

    const start = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }

        attemptsRef.current = 0
        setIsFetching(true)
        setProgressStatus(null)

        const pollOnce = async () => {
            attemptsRef.current++

            try {
                const result = await fetchPreCheckUpdateId(key)

                if (result.progressStatus && result.progressStatus !== progressStatusRef.current) {
                    setProgressStatus(result.progressStatus)
                }

                if (result.formUpdateId !== formUpdateIdRef.current) {
                    setIsFetching(false)
                    await onSuccessRef.current()
                    return
                }

                if (attemptsRef.current >= MAX_ATTEMPTS) {
                    setIsFetching(false)
                    onFailureRef.current()
                    return
                }

                timeoutRef.current = setTimeout(pollOnce, POLL_INTERVAL_MS)
            } catch (_e) {
                setIsFetching(false)
                onFailureRef.current()
            }
        }

        pollOnce()
    }

    return { isFetching, progressStatus, start }
}
